import { useHistory } from "react-router";

import { ROUTES } from "@config/soft.routing";

import { isLocalStorageAvailable } from "@services/IsLocalStorageAvailable";

import { LOCAL_STORAGE_KEY as LOCAL_STORAGE_KEY_BOOKINGS_TO_VALIDATE } from "@soft/redux/bookingsToValidate/bookingsToValidate.typings";

export const LocalStoragePurger = (): null => {
  const history = useHistory();
  if (history.location.pathname !== ROUTES.VALIDATE_CONTRACT) {
    if (isLocalStorageAvailable()) {
      localStorage.removeItem(LOCAL_STORAGE_KEY_BOOKINGS_TO_VALIDATE);
    }

    return null;
  }

  return null;
};
